export default 'https://tme.understood.org/assets/erlenmeyer.9c208f3c.glb'